module.exports = __webpack_public_path__ + "a28d3662eee5154f16f1143e0283f0d8.svg";